/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M1.5 4.87402L2.37393 8.29657L5.79648 7.42264"
      stroke="#010032"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.92492 12.5005C3.46525 14.0342 4.48937 15.3507 5.84297 16.2517C7.19657 17.1527 8.80632 17.5894 10.4297 17.4959C12.053 17.4025 13.6021 16.784 14.8434 15.7337C16.0846 14.6833 16.951 13.258 17.3118 11.6725C17.6726 10.087 17.5083 8.42716 16.8438 6.94311C16.1792 5.45906 15.0504 4.23119 13.6273 3.4445C12.2042 2.65781 10.564 2.35491 8.95382 2.58146C7.34363 2.808 5.85068 3.55171 4.69992 4.70053C4.69992 4.70053 3 6.50049 2.5 7.75049"
      stroke="#010032"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ReloadedIcon = (props) => <Icon component={svg} {...props} />;

export default ReloadedIcon;
